import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/joy";
import { useNavigate } from "react-router-dom";
import MultiTextTransition from "components/common/MultiTextTransition";
import { useRecoilValue } from "recoil";
import useMixpanelMKT from "../../../../hooks/useMixpanelMKT";
import { userSimpleAtom } from "../../../../recoil/userSimpleAtom";
import { useQuery } from "@tanstack/react-query";
import {
  WEB_FUNNEL_DEMOGRAPHIC_LOAD_ENDPOINT,
  WEB_FUNNEL_DOMAIN,
  webFunnelApi,
} from "../../../../api/webFunnelApi";
import useAutoLoginPromotion from "../../../../hooks/useAutoLoginPromotion";
import { OnboardingDemographicType } from "../../../../api/onboardingApi";

export default function CrossFunnel_Loading_Promotion() {
  const navigate = useNavigate();

  useAutoLoginPromotion();

  const [demographic, setDemographic] = useState<
    OnboardingDemographicType | undefined
  >(undefined);
  const user = useRecoilValue(userSimpleAtom);

  const trackMixpanel = useMixpanelMKT({
    eventName: "크로스 퍼널 로딩",
    version: "v4",
  });

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  const { data: demographicData } = useQuery(
    [WEB_FUNNEL_DOMAIN, WEB_FUNNEL_DEMOGRAPHIC_LOAD_ENDPOINT, user?.userId],
    () => webFunnelApi.loadDemographic(),
    {
      enabled: !!user?.accessToken && !!user?.userId,
      onSuccess: (data) => {
        if (data?.result) {
          setDemographic(data.result);

          sessionStorage.setItem(
            "demographic_data",
            JSON.stringify(data.result)
          );
        }
      },
    }
  );

  useEffectOnce(() => {
    trackMixpanel();
  });

  const handleNext = () => {
    if (
      user?.nickname &&
      demographic?.genderId &&
      demographic?.age &&
      demographic?.jobId
    ) {
      navigate("/promotion-onboarding/curriculum/1", { replace: true });
    } else {
      navigate("/promotion-onboarding/nickname/1", { replace: true });
    }
  };

  const textList = [
    "이미 디스턴싱에\n가입한 적이 있으시군요.",
    "이전 정보를\n불러오겠습니다.",
  ];

  return (
    <Box
      sx={{
        // 겹치는 두 개(텍스트 / 로고)를 같은 위치에 쌓아두기
        position: "relative",
        width: "100%",
      }}
    >
      <MultiTextTransition
        textList={textList}
        fadeInTime={1000}
        displayTime={2000}
        fadeOutTime={1000}
        onComplete={handleNext}
      />
    </Box>
  );
}
